import {
  CurrencyDollarIcon,
  FaceSmileIcon,
  RocketLaunchIcon,
} from "@heroicons/react/24/outline";
import { StopwatchIcon } from "@radix-ui/react-icons";
import { HTMLAttributes, forwardRef } from "react";
import { Navigate, Outlet, useNavigate, useParams } from "react-router-dom";
import { useGetSettings } from "src/api/General/settings";
import { classNames } from "src/utils/functions/classes";
import { cn } from "src/utils/ui/ui";

export default function Analytics() {
  const navigate = useNavigate();
  const { tab } = useParams();
  const { data: settings } = useGetSettings();
  if (!tab) {
    return <Navigate to="/analytics/projects" replace />;
  }
  // const [selectedTab, setSelectedTab] = useState<
  //   | "projects"
  //   | "time-tracking"
  //   | "project-templates"
  //   | "financials"
  //   | "resources"
  //   | "key-moments"
  // >(() => {
  //   const tab = localStorage.getItem(getAnalyticsTabKey()) as
  //     | "projects"
  //     | "time-tracking"
  //     | "project-templates"
  //     | "key-moments";
  //   if (!tab) {
  //     return "projects";
  //   }
  //   return tab;
  //   // return "time-tracking";
  // });

  // useEffect(() => {
  //   localStorage.setItem(getAnalyticsTabKey(), selectedTab);
  // }, [selectedTab]);

  // useEffect(() => {
  //   if (settings) {
  //     if (!settings.apps?.timeTracking && selectedTab === "time-tracking") {
  //       setSelectedTab("projects");
  //     }
  //   }
  // }, [settings]);
  return (
    <div className="flex h-full flex-col">
      <div className="flex h-12 shrink-0 items-center border-b border-gray-200/70 px-8 text-sm text-gray-800">
        Analytics
      </div>
      <div className="flex flex-1 overflow-auto">
        <div className="h-full w-64 space-y-0.5 border-r border-gray-200/70 px-5 pt-4">
          <AnalyticsTab
            Icon={
              <RocketLaunchIcon
                className={classNames(
                  tab === "projects"
                    ? "text-gray-800"
                    : "text-gray-700 group-hover:text-gray-800",
                  "h-4 w-4"
                )}
                aria-hidden="true"
              />
            }
            name="Projects"
            selected={tab === "projects"}
            onClick={() => {
              navigate("/analytics/projects");
            }}
            // route="/analytics/projects"
          />
          {/* {settings?.apps?.timeTracking && (
            <AnalyticsTab
              Icon={
                <StopwatchIcon
                  className={classNames(
                    tab === "time-tracking"
                      ? "text-gray-800"
                      : "text-gray-700 group-hover:text-gray-800",
                    "h-4 w-4"
                  )}
                  aria-hidden="true"
                />
              }
              selected={tab === "time-tracking"}
              name="Time Tracking"
              onClick={() => {
                navigate("/analytics/time-tracking");
              }}
            />
          )} */}
          {/* {settings?.apps?.timeTracking && (
            <AnalyticsTab
              Icon={
                <CurrencyDollarIcon
                  className={classNames(
                    tab === "financials"
                      ? "text-gray-800"
                      : "text-gray-700 group-hover:text-gray-800",
                    "h-4 w-4"
                  )}
                  aria-hidden="true"
                />
              }
              selected={tab === "financials"}
              name="Financials"
              onClick={() => {
                navigate("/analytics/financials");
              }}
            />
          )} */}

          {/* <AnalyticsTab
            Icon={
              <UserGroupIcon
                className={classNames(
                  selectedTab === "resources"
                    ? "text-gray-800"
                    : "text-gray-700 group-hover:text-gray-800",
                  "h-4 w-4"
                )}
                aria-hidden="true"
              />
            }
            selected={selectedTab === "resources"}
            name="Resources"
            onClick={() => {
              setSelectedTab("resources");
            }}
          />
          <AnalyticsTab
            Icon={
              <CurrencyDollarIcon
                className={classNames(
                  selectedTab === "financials"
                    ? "text-gray-800"
                    : "text-gray-700 group-hover:text-gray-800",
                  "h-4 w-4"
                )}
                aria-hidden="true"
              />
            }
            selected={selectedTab === "financials"}
            name="Financials"
            onClick={() => {
              setSelectedTab("financials");
            }}
          /> */}
          {/* <AnalyticsTab
            Icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                className={classNames(
                  tab === "project-templates"
                    ? "text-gray-800"
                    : "text-gray-700 group-hover:text-gray-800",
                  "h-4 w-4"
                )}
              >
                <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />
                <path d="M9 18h6" />
                <path d="M10 22h4" />
              </svg>
            }
            selected={tab === "key-moments"}
            name="Key Moments"
            onClick={() => {
              navigate("/analytics/key-moments");
            }}
          /> */}
          {/* <AnalyticsTab
            Icon={
              <FaceSmileIcon className={classNames(
                tab === "project-templates"
                  ? "text-gray-800"
                  : "text-gray-700 group-hover:text-gray-800",
                "h-4 w-4"
              )} />
            }
            selected={tab === "csat"}
            name="CSAT"
            onClick={() => {
              navigate("/analytics/csat");
            }}
          /> */}
          {/* <AnalyticsTab
            Icon={
              <RectangleStackIcon
                className={classNames(
                  selectedTab === "project-templates"
                    ? "text-gray-800"
                    : "text-gray-700 group-hover:text-gray-800",
                  "h-4 w-4"
                )}
                aria-hidden="true"
              />
            }
            selected={selectedTab === "project-templates"}
            name="Templates"
            onClick={() => {
              setSelectedTab("project-templates");
            }}
          /> */}
          {/* <div className="px-6">
            <div className="flex h-[30px] items-center space-x-2.5 rounded-md px-2 text-sm hover:bg-gray-100">
              <RocketLaunchIcon className="h-4 w-4" />
              <div>Projects</div>
            </div>
          </div> */}
        </div>
        <div className="flex-1">
          <Outlet />
        </div>
        {/* <div className="flex-1">
          {selectedTab === "projects" && <ProjectAnalyticsTabs />}
          {selectedTab === "time-tracking" && <TimeTrackingAnalyticsTabs />}
          {selectedTab === "financials" && <FinancialsAnalyticsTabs />}
          {selectedTab === "project-templates" && <TemplatesAnalyticsTabs />}
          {selectedTab === "key-moments" && <KeyMomentTab />}
        </div> */}
        {/* <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
          <AnalyticsCard
            onClick={() => {
              navigate("/analytics/guides");
            }}
          >
            <div className="flex items-center space-x-1.5">
              <MapIcon className="text-primary-500 h-[18px] w-[18px]" />
              <div className="text-base font-medium">Guides</div>
            </div>
            <div className="pt-1 text-sm text-gray-500">
              Explore our curated guides that focus on key datapoints.
            </div>
          </AnalyticsCard>
          <AnalyticsCard
            onClick={() => {
              navigate("/analytics/time-tracking");
            }}
          >
            <div className="flex items-center space-x-1.5">
              <StopwatchIcon className="text-primary-500 h-[18px] w-[18px]" />
              <div className="text-base font-medium">Time Tracking</div>
            </div>
            <div className="pt-1 text-sm text-gray-500">
              Understand the utilization of your team.
            </div>
          </AnalyticsCard>
          <AnalyticsCard
            onClick={() => {
              navigate("/analytics/financials");
            }}
          >
            <div className="flex items-center space-x-1.5">
              <CurrencyDollarIcon className="text-primary-500 h-[18px] w-[18px]" />
              <div className="text-base font-medium">Financials</div>
            </div>
            <div className="pt-1 text-sm text-gray-500">
              Study the financials of your projects.
            </div>
          </AnalyticsCard>
          <AnalyticsCard
            onClick={() => {
              navigate("/analytics/project-performance");
            }}
          >
            <div className="flex items-center space-x-2">
              <RocketLaunchIcon className="text-primary-500 h-[18px] w-[18px]" />
              <div className="text-base font-medium">Projects Explorer</div>
            </div>
            <div className="pt-1 text-sm text-gray-500">
              Dive deep into the performance of your projects.
            </div>
          </AnalyticsCard>

          <AnalyticsCard
            onClick={() => {
              navigate("/analytics/project-template-performance");
            }}
          >
            <div>
              <div className="flex items-center space-x-2">
                <RectangleStackIcon className="text-primary-500 h-[18px] w-[18px]" />
                <div className="text-base font-medium">Template Explorer</div>
              </div>
              <div className="pt-1 text-sm text-gray-500">
                Undertstand past performance of your templates & how you can
                iterate.
              </div>
            </div>
          </AnalyticsCard>
        </div> */}
      </div>
    </div>
  );
}

type AnalyticsTabProps = {
  // route: string;
  name: string;
  Icon: React.ReactNode;
  selected: boolean;
} & HTMLAttributes<HTMLDivElement>;

export const AnalyticsTab = forwardRef<HTMLDivElement, AnalyticsTabProps>(
  ({ children, className, Icon, name, selected, ...props }, ref) => {
    return (
      <div
        ref={ref}
        {...props}
        className={cn(
          "flex h-9 cursor-pointer items-center justify-start space-x-2 rounded-lg border-gray-200/70 pl-3 text-sm",
          selected
            ? "bg-gray-100/90 text-gray-800"
            : "text-gray-700 hover:bg-gray-100/90",
          className
        )}
      >
        {Icon}
        <div>{name}</div>
      </div>
      //   <div
      //     ref={ref}
      //     {...props}
      //     className={cn(
      //       "flex h-12 cursor-pointer items-center justify-start space-x-2 border-b border-gray-200/70 px-8 text-sm hover:bg-gray-50",
      //       className
      //     )}
      //   >
      //     {children}
      //   </div>
      //   <div className="flex h-12 cursor-pointer items-center justify-start space-x-2 border-b border-gray-200/70 px-8 text-sm hover:bg-gray-50">
      //   <StopwatchIcon className="h-4 w-4" />
      //   <div>Time Tracking</div>
      // </div>
    );
  }
);
